import React, { useState, useRef } from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import '../../../App.css';
import '../../../css/bootstrap.scss';
import doc_icon from "../../../images/upload_doc_icon.png";
import red_cross_icon from "../../../images/circle_cross.png";
import identity_card_banner from "../../../images/identity_card_banner.png";
import QRCode from "react-qr-code";
import BackButton from '../../Includes/BackButton';
import CameraModal from '../../Camera/CameraModal';
import SelfieCameraModal from '../../Camera/SelfieCameraModal';
import { reduxForm, InjectedFormProps } from 'redux-form';
import { connect, useDispatch, useSelector } from 'react-redux';
import { setpassportBackendPic, setpassportFrontendPic, setwizardPageNumber } from '../../authslice';
import { RootState } from '../../store';
import { ToastBox } from 'MyComponents/Toaster';
import Spacer from 'MyComponents/UI/Spacer';
import { updatePersonalKycDraftStep } from 'Utils/personalKycDraft';
import { useTranslation } from 'react-i18next';

interface Props {}

const UploadPassport: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props) => {
    const { t } = useTranslation();
    const BaseURL = process.env.REACT_APP_BASE_URL;
    const { handleSubmit } = props;
    const dispatch = useDispatch();
    const page = useSelector((state: RootState) => state.auth.wizardPageNumber);
    const theme = useSelector((state: RootState) => state.theme.theme);
    const userId = useSelector((state: RootState) => state.auth.userID);
    const kycToken = useSelector((state: RootState) => state.auth.kycToken);

    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const modalRef1 = useRef<string | null>(null);
    const modalRef2 = useRef<string | null>(null);

    const passportFrontendPic = useSelector((state: RootState) => state.auth.passportFrontendPic);
    const passportBackendPic = useSelector((state: RootState) => state.auth.passportBackendPic);

    const [srcModal1, setSrcModal1] = useState<string | null>(
        passportFrontendPic && passportFrontendPic.startsWith("data:image") ? passportFrontendPic : null
    );
    const [srcModal2, setSrcModal2] = useState<string | null>(
        passportBackendPic && passportBackendPic.startsWith("data:image") ? passportBackendPic : null
    );
    const [validated, setValidated] = useState(false);

    const updateSrcModal1 = (newState: string) => {
        dispatch(setpassportFrontendPic(newState));
        setSrcModal1(newState);
        setValidated(false);
    };

    const updateSrcModal2 = (newState: string) => {
        dispatch(setpassportBackendPic(newState));
        setSrcModal2(newState);
    };

    const handleModal1CrossIconClick = () => { setSrcModal1(null); dispatch(setpassportFrontendPic("")); };
    const handleModal2CrossIconClick = () => { setSrcModal2(null); dispatch(setpassportBackendPic("")); };

    const submitForm = () => {
        if (!srcModal1) { setValidated(true); return; }
        dispatch(setwizardPageNumber(page + 1));
        localStorage.setItem('pageNumber', `${page + 1}`);
    };

    const saveExit = () => {
        if (!srcModal1) { setValidated(true); return; }
        dispatch(setwizardPageNumber(page + 1));
        localStorage.setItem('pageNumber', `${page + 1}`);

        if (userId) {
            updatePersonalKycDraftStep(userId, 'idVerification', {
                passportFrontendPic: srcModal1,
                passportBackendPic: srcModal2
            });
            updatePersonalKycDraftStep(userId, 'wizardState', { pageNumber: page + 1 });
        }
    };

    return (
        <>
            <ToastBox />
            <CameraModal show={showModal1} handleClose={() => setShowModal1(false)} title="Passport" ref={modalRef1} side="Front side of" updateSrc={updateSrcModal1} />
            <SelfieCameraModal show={showModal2} handleClose={() => setShowModal2(false)} title="Passport" ref={modalRef2} side="Back side of" updateSrc={updateSrcModal2} />

            <Container fluid>
                <Row>
                    <Col md={12}>
                        <div className="">
                            <Row className="px-2 px-md-5"><Col md={12}><BackButton /></Col></Row>

                            <Row className="px-2 px-md-5">
                                <Col md={12}>
                                    <div className="d-flex align-items-start py-3">
                                        <img src={doc_icon} width={48} className="me-3 mt-1" alt="doc icon" />
                                        <div>
                                            <h3 className="text-start m-0">{t('kyc.upload_passport')}</h3>
                                            <p className="fw-normal text-secondary m-0 mt-1">{t('kyc.confirm_secure')}</p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Form noValidate onSubmit={handleSubmit(submitForm)}>
                                <Row className="px-2 px-md-5">
                                    <Col md={12} className="rounded-3">
                                        <Row className="p-2 p-md-4">
                                            <Col xs={12} md={4}>
                                                <p className="fw-bold small mb-2">{t('kyc.front_passport')}</p>
                                                <div
                                                    onClick={() => setShowModal1(true)}
                                                    className="text-center position-relative d-flex flex-column justify-content-center align-items-center mb-3"
                                                    style={{
                                                        border: `2px dashed ${validated && !srcModal1 ? "#dc3545" : "#C9DAF8"}`,
                                                        borderRadius: "12px",
                                                        height: "140px",
                                                        background: theme === "dark" ? "#1a1a1a" : "#EDF7F3",
                                                        cursor: "pointer",
                                                        transition: "all 0.2s ease",
                                                    }}
                                                >
                                                    {srcModal1 ? (
                                                        <>
                                                            <img src={red_cross_icon} onClick={(e) => { e.stopPropagation(); handleModal1CrossIconClick(); }}
                                                                style={{ position: "absolute", top: "6px", right: "6px", width: "20px", cursor: "pointer", zIndex: 2 }} alt="remove" />
                                                            <img src={srcModal1} alt="Front Passport" className="img-fluid rounded-3 object-fit-cover w-100 h-100" />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fa-solid fa-camera" style={{ fontSize: '32px', color: '#00D084' }} />
                                                            <p className="fw-normal small mt-2 mb-0 text-secondary">{t('camera.take_photo')}</p>
                                                        </>
                                                    )}
                                                </div>
                                                {validated && !srcModal1 && (
                                                    <div className="text-danger small mt-1 fw-bold">
                                                        {t('kyc.passport_img_required')}
                                                    </div>
                                                )}

                                                <p className="fw-bold small mb-2">{t('kyc.back_passport')}</p>
                                                <div
                                                    onClick={() => setShowModal2(true)}
                                                    className="text-center position-relative d-flex flex-column justify-content-center align-items-center"
                                                    style={{
                                                        border: "2px dashed #C9DAF8",
                                                        borderRadius: "12px",
                                                        height: "140px",
                                                        background: theme === "dark" ? "#1a1a1a" : "#EDF7F3",
                                                        cursor: "pointer",
                                                        transition: "all 0.2s ease",
                                                    }}
                                                >
                                                    {srcModal2 ? (
                                                        <>
                                                            <img src={red_cross_icon} onClick={(e) => { e.stopPropagation(); handleModal2CrossIconClick(); }}
                                                                style={{ position: "absolute", top: "6px", right: "6px", width: "20px", cursor: "pointer", zIndex: 2 }} alt="remove" />
                                                            <img src={srcModal2} alt="Back Passport" className="img-fluid rounded-3 object-fit-cover w-100 h-100" />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fa-solid fa-camera" style={{ fontSize: '32px', color: '#00D084' }} />
                                                            <p className="fw-normal small mt-2 mb-0 text-secondary">{t('camera.take_photo')}</p>
                                                        </>
                                                    )}
                                                </div>
                                            </Col>

                                            <Col md={4} className="d-none d-md-block">
                                                <p className='fw-bold ms-2 mb-1'>{t('kyc.qr_code')}</p>
                                                <Row className={`ms-2 justify-content-center rounded-3 ${theme === "light" && "bg-sky"} mt-3`}>
                                                    <div style={{ width: 256, margin: "20px auto 0" }}>
                                                        <QRCode value={`${BaseURL}/kyc/personal/${userId}/${kycToken}`} size={256} style={{ width: "100%", height: "auto" }} />
                                                    </div>
                                                    <p className='fw-bold text-center mt-2'>{t('kyc.qr_scan_title')}</p>
                                                    <p className='fw-normal text-secondary small text-center mb-5'>{t('kyc.qr_scan_desc')}</p>
                                                </Row>
                                            </Col>

                                            <Col md={4} className='mt-4 d-none d-md-block'>
                                                <Row className={`justify-content-center rounded-3 mt-3 ms-2 ${theme === "light" && "bg-sky"}`}>
                                                    <div className='text-center'>
                                                        <img className='mt-3 ms-2 py-3 text-center' src={identity_card_banner} width={153} height={125} alt="banner" />
                                                    </div>
                                                    <Row className='justify-content-center rounded-2 px-4 mb-2'>
                                                        <p className='fw-bold small'>{t('kyc.doc_standards_title')}</p>
                                                        <ul className="list-group border-0 bg-transparent fw-normal">
                                                            <li className="list-group-item border-0 bg-transparent text-secondary p-0 small">{t('kyc.doc_clear')}</li>
                                                            <li className="list-group-item border-0 bg-transparent text-secondary p-0 small">{t('kyc.doc_not_reflective')}</li>
                                                            <li className="list-group-item border-0 bg-transparent text-secondary p-0 small">{t('kyc.doc_no_edit')}</li>
                                                            <li className="list-group-item border-0 bg-transparent text-secondary p-0 small">{t('kyc.doc_solid_bg')}</li>
                                                        </ul>
                                                    </Row>
                                                </Row>
                                            </Col>

                                            <Col md={12} className="d-flex justify-content-end mt-4">
                                                <Button className="btn btn-primary rounded-5" onClick={saveExit}>
                                                    {t('common.save')}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizard',
    enableReinitialize: true,
})(UploadPassport);

export default connect(null)(form);
